import Vue from 'vue'
import Vuex from 'vuex'
Vue.use(Vuex)
let store = new Vuex.Store({
  state: {
    openid: '',
    id: '',
    idCar: '',
    cityId: '',
    phone: '',
    companyName: '',
    companyPhone: '',
    workType: '',
    needExam: ''
  },
  mutations: {
    OPENID: (state, data) => {
      state.openid = data
      localStorage.setItem('recruit_openid', data)
      localStorage.setItem('store', JSON.stringify(state))
    },
    ID: (state, data) => {
      state.id = data
      localStorage.setItem('store', JSON.stringify(state))
    },
    IDCAR: (state, data) => {
      state.idCar = data
      localStorage.setItem('store', JSON.stringify(state))
    },
    CITYID: (state, data) => {
      state.cityId = data
      localStorage.setItem('store', JSON.stringify(state))
    },
    PHONE: (state, data) => {
      state.phone = data
      localStorage.setItem('store', JSON.stringify(state))
    },
    CNAME: (state, data) => {
      state.companyName = data
      localStorage.setItem('store', JSON.stringify(state))
    },
    CPHONE: (state, data) => {
      state.companyPhone = data
      localStorage.setItem('store', JSON.stringify(state))
    },
    WORKTYPE: (state, data) => {
      state.workType = data
      localStorage.setItem('store', JSON.stringify(state))
    },
    NEEDEXAM: (state, data) => {
      state.needExam = data
      localStorage.setItem('store', JSON.stringify(state))
    }
  }
})
export default store



// WEBPACK FOOTER //
// ./src/store/index.js